import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@valhalla/core';
import { ILanguageDescription } from '@valhalla/data/entities';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IApiResponse } from '../api-response';
import { DataHttpCommonService } from '../data-http-common.service';
import { ILocalizationSetLanguageCriteria, LocalizationDataHttpService } from './abstract';

@Injectable()
export class LocalizationDataHttpServiceImpl implements LocalizationDataHttpService {
	constructor(readonly http: HttpClient, readonly common: DataHttpCommonService, readonly auth: AuthService) {}

	getLanguages(): Observable<Array<ILanguageDescription>> {
		const url = this.common.getApiUrl(`languages`);
		return this.http.get<IApiResponse<Array<ILanguageDescription>>>(url).pipe(map(({ data }) => data));
	}

	getCurrentLanguage(): Observable<ILanguageDescription> {
		const url = this.common.getApiUrl(`languages/user`);
		return this.http.get<IApiResponse<ILanguageDescription>>(url).pipe(map(({ data }) => data));
	}

	setLanguage({ alias }: ILocalizationSetLanguageCriteria, allowNotification?: boolean): Observable<any> {
		const url = this.common.getApiUrl(`user/${this.auth.userId}/language`);
		return this.http.post<any>(url, { language: alias, allowNotification: allowNotification });
	}
}
